var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsDateString, IsUUID } from 'class-validator';
export class ExerciseUploadDto {
    token;
    userId;
    createdAt = new Date();
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ExerciseUploadDto.prototype, "token", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ExerciseUploadDto.prototype, "userId", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], ExerciseUploadDto.prototype, "createdAt", void 0);
//# sourceMappingURL=exercise-upload.dto.js.map